module.exports = __webpack_public_path__ + "img/course_img1.80417de8.jpg";